/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'basic',
    icon: 'dashboard',
    link: '/dashboard',
    isHidden:true
  },
  {
    id: 'activity',
    title: 'Activity',
    type: 'basic',
    icon: 'activity',
    link: '/activities',
    isHidden: true
  },
  {
    'id': 'post_order',
    'title': 'JobInstruction',
    'type': 'basic',
    'icon': 'post_order',
    link: '/job-instruction',
    isHidden: true
  },
  {
    id: '_joborder',
    title: 'JobOrder',
    type: 'basic',
    'icon': 'groups',
    link: '/job-order',
    isHidden: false
  },
  {
    'id': 'tracker',
    'title': 'GPS Tracker',
    'type': 'collapsable',
    'icon': 'gps_tracker',
    isHidden: true,
    'children': [
      {
        'id': 'live_tracking',
        'title': 'Live Tracking',
        'type': 'basic',
        'link': '/live-tracking'
      },
      {
        'id': 'tracking_history',
        'title': 'Tracking History',
        'type': 'basic',
        'link': '/tracking-history'
      }
    ]
  },
  {
    'id': 'time_clock',
    'title': 'Time Clock',
    'type': 'collapsable',
    'icon': 'time_clock',
    isHidden: true,
    'children': [
      {
        'id': 'time_log',
        'title': 'Time Logs',
        'type': 'basic',
        'link': '/time-log'
      },
      {
        'id': 'time_card',
        'title': 'Time Card',
        'type': 'basic',
        'link': '/time-card'
      },

    ]
  },
  {
    id: 'reports',
    title: 'Reports',
    type: 'basic',
    icon: 'reports',
    link: '/reports',
    isHidden: true
  },
  {
    'id': 'scheduler',
    'title': 'Scheduler',
    'type': 'collapsable',
    'link': '/schedule',
    'icon': 'scheduler',
    isHidden: true,
    'children': [
      {
        'id': 'schedule',
        'title': 'Schedule',
        'type': 'basic',
        'link': '/schedule'
      },
      {
        'id': 'shift_templates',
        'title': 'Shift Templates',
        'type': 'basic',
        'link': '/shift-templates'
      },
      {
        'id': 'shift-status',
        'title': 'Shift Status',
        'type': 'basic',
        'link': '/shift-status'
      },
    ]
  },
  {
    id: 'dispatcher',
    title: 'Dispatcher',
    type: 'basic',
    icon: 'dispatcher',
    link: '/dispatch-tickets',
    isHidden: true
  },
  {
    'id': 'docSign',
    'title': 'DocSign',
    'type': 'collapsable',
    'icon': 'heroicons_outline:pencil-square',
    isHidden: false,
    'children': [
      {
        'id': '_overview',
        'title': 'Overview',
        'type': 'basic',
        'link': '/Overview'
      },
      {
        'id': 'documents',
        'title': 'Documents',
        'type': 'basic',
        'link': '/documents'
      },
      {
        'id': 'templates',
        'title': 'Templates',
        'type': 'basic',
        'link': '/templates'
      },     
    ]
  },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
